var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBarcodeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 36.094,
    viewBox: "0 0 42 36.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "barcode_1_",
    "data-name": "barcode (1)",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M-18.365,3.011A1.64,1.64,0,0,1-20,1.367V-18.356A1.64,1.64,0,0,1-18.365-20a1.64,1.64,0,0,1,1.635,1.644V1.367A1.64,1.64,0,0,1-18.365,3.011Z",
    transform: "translate(26.215 62.542)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M-18.365-3.646A1.635,1.635,0,0,1-20-5.281V-18.365A1.635,1.635,0,0,1-18.365-20a1.635,1.635,0,0,1,1.635,1.635V-5.281A1.635,1.635,0,0,1-18.365-3.646Z",
    transform: "translate(32.8 62.58)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M-18.365,3.011A1.64,1.64,0,0,1-20,1.367V-18.356A1.64,1.64,0,0,1-18.365-20a1.64,1.64,0,0,1,1.635,1.644V1.367A1.64,1.64,0,0,1-18.365,3.011Z",
    transform: "translate(39.365 62.542)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M-18.365-3.646A1.635,1.635,0,0,1-20-5.281V-18.365A1.635,1.635,0,0,1-18.365-20a1.635,1.635,0,0,1,1.635,1.635V-5.281A1.635,1.635,0,0,1-18.365-3.646Z",
    transform: "translate(45.929 62.58)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M-18.365,3.011A1.64,1.64,0,0,1-20,1.367V-18.356A1.64,1.64,0,0,1-18.365-20a1.64,1.64,0,0,1,1.635,1.644V1.367A1.64,1.64,0,0,1-18.365,3.011Z",
    transform: "translate(52.515 62.542)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1.635,45.812A1.635,1.635,0,0,1,0,44.177V40.906A4.912,4.912,0,0,1,4.906,36H8.177a1.635,1.635,0,0,1,0,3.271H4.906a1.637,1.637,0,0,0-1.635,1.635v3.271A1.635,1.635,0,0,1,1.635,45.812Z",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M400.177,45.812a1.635,1.635,0,0,1-1.635-1.635V40.906a1.637,1.637,0,0,0-1.635-1.635h-3.271a1.635,1.635,0,0,1,0-3.271h3.271a4.912,4.912,0,0,1,4.906,4.906v3.271A1.635,1.635,0,0,1,400.177,45.812Z",
    transform: "translate(-359.812)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M396.906,365.812h-3.271a1.635,1.635,0,1,1,0-3.271h3.271a1.637,1.637,0,0,0,1.635-1.635v-3.271a1.635,1.635,0,0,1,3.271,0v3.271A4.912,4.912,0,0,1,396.906,365.812Z",
    transform: "translate(-359.812 -293.719)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M8.177,365.812H4.906A4.912,4.912,0,0,1,0,360.906v-3.271a1.635,1.635,0,0,1,3.271,0v3.271a1.637,1.637,0,0,0,1.635,1.635H8.177a1.635,1.635,0,1,1,0,3.271Z",
    transform: "translate(0 -293.719)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    transform: "translate(27.563 63.891)",
    fill: "#9f393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    transform: "translate(14.438 63.891)",
    fill: "#9f393a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcodeRed);
export default __webpack_public_path__ + "static/media/icon-barcode-red.5b58cc22e7b51cc9e5b986d573ef1ce3.svg";
export { ForwardRef as ReactComponent };